import { getIn, useFormikContext } from 'formik';

import { StoreAutoComplete } from 'components/autocompletes';
import { Block } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { Revendedor } from 'pages/revendedor/revendedor/types';

export function RevendedorAutoCompletesBlock() {
    const { values, errors, setFieldValue } = useFormikContext<Revendedor>();
    const { hasPermission } = usePermissionsContext();
    const disabledLoja = !hasPermission(['REVENDEDOR_CADASTRO_CONFIGURACOES']);

    return (
        <Block sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <StoreAutoComplete
                disabled={disabledLoja}
                defaultStore={false}
                importStores={false}
                label="Loja"
                name="loja"
                value={values.loja}
                error={getIn(errors, 'loja')}
                onChange={(e, loja) => setFieldValue('loja', loja)}
            />
        </Block>
    );
}
